module.exports = __webpack_public_path__ + "img/hotel.432436b2.gif";